import React from 'react';
import PropTypes from 'prop-types';
import * as Styles from './index.styles';
import HorizontalLogo from './assets/horizontal.svg';
import VerticalLogo from './assets/vertical.svg';
import NoTextLogo from './assets/no-text.svg';
import HorizontalWhite from './assets/horizontal-branco.svg';
import HorizontalBlack from './assets/horizontal-preto.svg';
import VerticalWhite from './assets/vertical-branco.svg';
import VerticalBlack from './assets/vertical-preto.svg';
import NoTextWhite from './assets/no-text-branco.svg';
import NoTextBlack from './assets/no-text-preto.svg';
import SoloWhite from './assets/solo-branco.svg';
import SoloBlack from './assets/solo-preto.svg';

const { StyledLogo } = Styles;

const defaultValues = {
    horizontal: {
        width: '340px',
        height: '40px',
        logo: HorizontalLogo,
    },
    vertical: {
        width: '153px',
        height: '42px',
        logo: VerticalLogo,
    },
    noText: {
        width: '134px',
        height: '37px',
        logo: NoTextLogo,
    },
    horizontalWhite: {
        width: '340px',
        height: '40px',
        logo: HorizontalWhite,
    },
    horizontalBlack: {
        width: '340px',
        height: '40px',
        logo: HorizontalBlack,
    },
    verticalWhite: {
        width: '153px',
        height: '42px',
        logo: VerticalWhite,
    },
    thinVerticalWhite: {
        width: '106.16px',
        height: '29.4px',
        logo: VerticalWhite,
    },
    verticalBlack: {
        width: '153px',
        height: '42px',
        logo: VerticalBlack,
    },
    noTextWhite: {
        width: '100px',
        height: '24px',
        logo: NoTextWhite,
    },
    noTextBlack: {
        width: '130px',
        height: '30px',
        logo: NoTextBlack,
    },
    soloBlack: {
        width: '153px',
        height: '42px',
        logo: SoloBlack,
    },
    soloWhite: {
        width: '153px',
        height: '42px',
        logo: SoloWhite,
    },
    thinSoloWhite: {
        width: '42px',
        height: '42px',
        logo: SoloWhite,
    },
    smallSoloWhite: {
        width: '24px',
        height: '24px',
        logo: SoloWhite,
    },
};

export const Logo = ({ type, ...otherProps }) => (
    <StyledLogo type={type} {...otherProps}>
        <img
            src={defaultValues[type].logo}
            alt="logo"
            height={defaultValues[type].height}
            width={defaultValues[type].width}
        />
    </StyledLogo>
);

Logo.propTypes = {
    type: PropTypes.string,
};

Logo.defaultProps = {
    type: 'horizontal',
};

Logo.Styles = Styles;
